import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


  <iframe id="form" title="accessibility form" width="100%" height="1100px" src="https://acrobatusers.com/documentcloud_sdk/index_lead_gen.php?api=accessibility">
  </iframe>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      